export default __webpack_public_path__ + "assets/images/logo.bd545ee26d0ece7ebcc061b955e8818a.svg";